// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-source-info-___source-info__source-info-list___j6T_k {
  padding: 0;
  list-style: none;
}
  
.src-components-source-info-___source-info__source-info-list-item___N74g7 {
  display: inline;
}
  
.src-components-source-info-___source-info__source-info-link___G7WM4 {
  color: black;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/source-info/source-info.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".source-info-list {\n  padding: 0;\n  list-style: none;\n}\n  \n.source-info-list-item {\n  display: inline;\n}\n  \n.source-info-link {\n  color: black;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"source-info-list": `src-components-source-info-___source-info__source-info-list___j6T_k`,
	"sourceInfoList": `src-components-source-info-___source-info__source-info-list___j6T_k`,
	"source-info-list-item": `src-components-source-info-___source-info__source-info-list-item___N74g7`,
	"sourceInfoListItem": `src-components-source-info-___source-info__source-info-list-item___N74g7`,
	"source-info-link": `src-components-source-info-___source-info__source-info-link___G7WM4`,
	"sourceInfoLink": `src-components-source-info-___source-info__source-info-link___G7WM4`
};
export default ___CSS_LOADER_EXPORT___;
